import React, { FunctionComponent } from 'react';
import VisitPhotoReview from './components/VisitPhotoReview';
interface IVisitReviews {}
const VisitReviews: FunctionComponent<IVisitReviews> = () => {
  return <VisitPhotoReview />;
};

export default VisitReviews;
